export default {
  relationship: {
    title: "Связь платежей и пачек",
    linkForm: {
      modal: {
        title: "Связь платежа и пачки"
      },
      form: {
        cardPayment: {
          header: "Платеж"
        },
        cardPack: {
          header: "Пачка"
        },
        codefirme: {
          title: "Организация"
        },
        datebank: {
          title: "Дата по банку"
        },
        datepay: {
          title: "Дата оплаты"
        },
        summa: {
          title: "Сумма"
        },
        sumprof: {
          title: "За услуги"
        },
        status: {
          title: "Сумма платежа включает в себя комиссионный сбор"
        },
        quantity: {
          title: "Квитанций"
        },
        countband: {
          title: "Бандеролей"
        },
        difference: {
          title: "Расхождение между суммами платежа и пачки"
        },
        userid: {
          title: "Назначенный оператор"
        }
      }
    },
    searchErrorPaymentsForm: {
      modal: {
        title: "Поиск ошибочного платежа"
      },
      form: {
        abcode: "Лицевой счет",
        sumPay: "Сумма платежа",
        dateBank: "Дата по банку",
        datePay: "Дата оплаты",
        dateChange: "Дата изменения",
        and: "и",
        errorType: "Тип ошибки",
        npack: "Номер пачки",
        datePayFrom: "Период оплаты с",
        datePayTo: "по",
        kindpay: "Тип оплаты",
        codefirme: "Плательщик",
        note: "Примечание"
      },
      extendedSearch: "F2 - Расширенный поиск",
      confirm: {
        searchTermNotSpecified:
          "Не указано условие поиска. Показать все платежи?",
        veryMuchPayments:
          "Таких платежей может быть очень много и их загрузка может занять длительное время. Вы уверены, что хотите увидеть все такие платежи?"
      }
    },
    errorPaymentsForm: {
      modal: {
        title: "Исправление и разноска ошибочных платежей"
      },
      autoDistribute: "F2 - Автоматически разнести платеж после изменения"
    },
    paymentsRelationColumn: {
      headers: {
        paymentsRelation: "Платежи"
      }
    },
    packsRelationColumn: {
      headers: {
        packsRelation: "Пачки"
      }
    },
    packsInternetRelationColumn: {
      headers: {
        packsInternetRelation: "Internet-пачки"
      }
    },
    linkConfirm: {
      title: "Связь платежа и пачки",
      linkPayment: "Связать платеж",
      for: "за",
      from: "от",
      inAmount: "на сумму",
      withRecPay: "с поступившими оплатами",
      pcs: "шт",
      attention:
        "Внимание! Данные платежа и пачки отличаются друг от друга. Желаете связать их в любом случае?"
    },
    linkResultTitle: "Результат"
  }
};
